import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/WindowsBlock.module.scss'

import { Container, Card, Image, Button } from 'react-bootstrap'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox'
import WhiteBlockTitle from './WhiteBlockTitle'
import FeedbackForm from './FeedbackForm'
import GreenButton from './GreenButton'

class WindowsBlock extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      show_feedback: false,
      feedback_name: ``,
      lightboxController: {
        toggler: false,
        slide: 1
      }
    };
  }

  showFeedback = ( feedback_name ) => {
    this.setState({ show_feedback: true, feedback_name: feedback_name });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false, feedback_name: `` });
  }

  // Функция для открытия лайтбокса
  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  formatSlideNumber = (index) => {
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { data, margin } = this.props,
    { show_feedback, feedback_name, lightboxController } = this.state

    return (
      <section className={`${styles.section} ${styles[margin]}`}>
        <Container>
          {/* Lightbox компонент */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={data?.list.map(item => item.full || item.image)}
            slide={lightboxController.slide}
          />

          {data?.title != `` &&
            <WhiteBlockTitle
              title={data?.title || ``}
              text={data?.text || ``}
            />
          }
          <div className={styles.list2}>
            {data?.list.map( ( elm, k ) => (
              <Card className={styles.card} key={k}>
                <Card.Body>
                  <Card.Text>{this.formatSlideNumber(k)}</Card.Text>
                </Card.Body>
                {/* Добавляем обработчик клика для открытия изображения в лайтбоксе */}
                <Card.Img 
                  as='div' 
                  className={styles.card_image}
                  onClick={() => { this.showFeedback( elm?.name ) }}
                  style={{cursor: 'pointer'}}
                >
                  <Image src={elm?.image} alt={elm?.name} width={202} height={123} />
                </Card.Img>
                <Card.Body>
                  <Card.Title className={styles.card_title}>{elm?.name}</Card.Title>
                  <Card.Text className={styles.card_text}>{elm?.price}</Card.Text>
                  <GreenButton
                    text={`Заказать звонок`}
                    width={198}
                    addClass={`white`}
                    action={() => { this.showFeedback( elm?.name ) }}
                    className={styles.card_btn}
                  />
                </Card.Body>
              </Card>
            ) )}
            {data?.rimg != `` &&
              <div className={styles.rcard_image}>
                <Image className={styles.card_image_img} src={data?.rimg} alt={`Заказать замер окон`} width={466} height={301} />
                <div className={styles.card_image_btn}>
                  <GreenButton
                    text={`Заказать звонок`}
                    action={() => { this.showFeedback(`Заказать звонок`) }}
                    width={175}
                  />
                </div>
              </div>
            }
            <FeedbackForm
              title={`Заказать звонок`}
              text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
              btn={`Отправить`}
              data={[
                {
                  name: `Тип окон`,
                  value: feedback_name
                }
              ]}
              show={show_feedback}
              handleClose={() => this.closeFeedback()}
            />
          </div>
          {data?.rimg != `` &&
            <div className={styles.rcard_image_mob}>
              <Image className={styles.card_image_img} src={data?.rimg_mob} alt={`Заказать замер окон`} width={466} height={301} />
              <div className={styles.card_image_btn}>
                <GreenButton
                  text={`Заказать звонок`}
                  action={() => { this.showFeedback(`Заказать звонок`) }}
                  width={175}
                />
              </div>
            </div>
          }
        </Container>
      </section>
    )
  }
}

WindowsBlock.propTypes = {
  data: PropTypes.object,
  margin: PropTypes.string
}

WindowsBlock.defaultProps = {
  data: {},
  margin: `y`
}

export default WindowsBlock